/**
 * Timer mode helper functions
 * Handles switching between manual and timer modes
 */

import { resetManualTimeState } from "./manualTimeHelpers";

/**
 * Creates timer mode handlers (manual/timer toggle)
 * @param {Object} dependencies - Object containing all necessary dependencies
 */
export const createTimerModeHandlers = ({
  // State values
  projectDropdownOpen,
  tagDropdownOpen,
  uManualStartTimeError,
  uManualEndTimeError,
  uManualFormatedTimeError,
  // Setters
  setCustomeTime,
  setDate,
  setProjectDropdownOpen,
  setTagDropdownOpen,
  setSplitted,
  setSplittedDate,
  setUManualStartTimeError,
  setUManualEndTimeError,
  setUManualFormatedTimeError,
  setStartTimeManual,
  setEndTimeManual,
  setStartTimeManual24,
  setEndTimeManual24,
  setUFormatedTimeManual,
  setTaskError,
}) => {
  /**
   * Handle manual mode click
   */
  const handleManualClick = () => {
    try {
      setCustomeTime(true);
      if (setTaskError) setTaskError(null);
      resetManualTimeState({
        setStartTimeManual,
        setEndTimeManual,
        setStartTimeManual24,
        setEndTimeManual24,
        setUFormatedTimeManual,
        setSplitted,
        setSplittedDate,
        setUManualStartTimeError,
        setUManualEndTimeError,
        setUManualFormatedTimeError,
      });
      setDate(new Date());

      try {
        if (
          uManualStartTimeError ||
          uManualEndTimeError ||
          uManualFormatedTimeError
        ) {
          setUManualStartTimeError(false);
          setUManualEndTimeError(false);
          setUManualFormatedTimeError(false);
        }
      } catch (err) {
        console.error("Error resetting manual time errors:", err);
      }

      try {
        if (projectDropdownOpen) {
          setProjectDropdownOpen(false);
        }
        if (tagDropdownOpen) {
          setTagDropdownOpen(false);
        }
      } catch (dropdownErr) {
        console.error("Error handling dropdown states:", dropdownErr);
      }

    } catch (error) {
      console.error("Unexpected error in handleManualClick:", error);
    }
  };

  /**
   * Handle timer mode click
   */
  const handleTimerClick = () => {
    try {
      setCustomeTime(false);
      if (setTaskError) setTaskError(null);
      setSplitted(false);
      setSplittedDate([]);

      try {
        if (projectDropdownOpen) {
          setProjectDropdownOpen(false);
        }
        if (tagDropdownOpen) {
          setTagDropdownOpen(false);
        }
      } catch (dropdownErr) {
        console.error("Error handling dropdown states in handleTimerClick:", dropdownErr);
      }

    } catch (error) {
      console.error("Unexpected error in handleTimerClick:", error);
    }
  };

  return {
    handleManualClick,
    handleTimerClick,
  };
};
